import { ReactElement, useRef } from "react";
import styles from "./Filter.module.scss";

interface FilterProps<TData>
{
    data: TData[];
    filter: string;
    onFilter: (filter: string) => void;
}

function Filter<TData>(props: FilterProps<TData>): ReactElement
{
    const filter = props.filter;
    const lastSearchRef = useRef<string>("");

    function onFilter(value: string): void
    {
        props.onFilter(value);
    }

    function reset(): void
    {
        if (lastSearchRef.current !== "") {
            lastSearchRef.current = "";
        };

        props.onFilter("");
    }

    return (
        <div className={styles.filterWrapper}>
            <input
                type="text"
                id="filterText"
                name="filterText"
                placeholder="Filter..."
                autoComplete="off"
                value={filter}
                onChange={e => onFilter(e.target.value)}
            />
            {(filter !== "" || filter !== lastSearchRef.current) && (
            <button
                className={styles.resetBtn}
                onClick={reset}
            >
                <i className="material-icons">close</i>
            </button>
            )}
        </div>
    );
}

export default Filter;
